import React, { Component } from 'react';
import LoginAnnouncementModal from '../in-modal/login-announcement/main';
import { Common } from '../../core/common';
import { Log } from 'ng2-logger';
import { Modal } from 'reactstrap';
import ReactDOM from 'react-dom';
import { Guid } from 'guid-typescript';

interface IBaseModalProps {
    headerState: string;
    headerIcon?: string;
    modalIsOpen?: boolean;
    onClose?: any;
    minWidth?: any;
    backdrop?: string;
    modalFooter?: any;
    showHeader?: boolean;
    modalBodyClassName?: string;
    modalHeaderClassName?: string;
    modalContentClassName?: string;
}

const _logger = Log.create('Base Modal Static');
let _common: Common;

const portal = document.createElement('div');
document.body.appendChild(portal);

const key = Guid.create().toString();
class BaseModalStatic extends Component<IBaseModalProps> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.setCloseModal.bind(this);
    }

    setClose = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    setCloseModal = (e: any) => {
        if (e && e.target && e.target.id) {
            
            if (e.target.id === 'add-question-file-modal-dialog-' + key) {
                this.setClose();
            }        
        }          
    };

    modal = () => {
        const child = (
            <React.Fragment>
                <div
                    className="modal fade show"
                    role="dialog"
                    style={{ display: this.props.modalIsOpen ? 'block' : 'none', zIndex: 1070 }}
                    id={'add-question-file-modal-dialog-' + key}
                    onClick={this.setCloseModal}
                >
                    <div
                        className="modal-dialog question-modal exam-modal-stats"
                        role="document"
                        style={{ minWidth: this.props.minWidth ? this.props.minWidth : null }}
                    >
                        <div className={this.props.modalContentClassName ? this.props.modalContentClassName : 'modal-content'}>
                            <div
                                className={
                                    this.props.modalHeaderClassName
                                        ? this.props.modalHeaderClassName
                                        : 'modal-header border-0 d-flex justify-content-between p-0'
                                }
                                id={'add-question-file-modal-dialog-' + key}
                                onClick={this.setCloseModal}
                                style={{ marginBottom: 0 }}
                            >
                                {this.props.showHeader && (
                                    <h5
                                        className="modal-title d-inline-flex align-items-center pt-0"
                                        id="exampleModalLabel"
                                        style={{ marginBottom: 10 }}
                                    >
                                        {this.props.headerIcon && (
                                            <img
                                                className="mr-4"
                                                style={{ width: 40 }}
                                                src={_common.GetActivityIcons(this.props.headerIcon)}
                                                alt="icon"
                                            />
                                        )}
                                        <p className="mb-0" dangerouslySetInnerHTML={{ __html: this.props.headerState }} />
                                    </h5>
                                )}
                                 <a type="button" className="close" 
                                    onClick={this.setCloseModal}
                                    id={'add-question-file-modal-dialog-' + key}>
                                    <span id={'add-question-file-modal-dialog-' + key}>×</span>
                                </a>
                            </div>
                            <div className={this.props.modalBodyClassName ? this.props.modalBodyClassName : 'modal-body pt-0'}>
                                {this.props.children}
                            </div>
                            {this.props.modalFooter ? this.props.modalFooter() : ''}
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show" 
                style={{ display: this.props.modalIsOpen ? 'block' : 'none', zIndex: 1060 }}/>
            </React.Fragment>
        );

        return ReactDOM.createPortal(child, portal);
    };

    public render() {
        return this.modal();
    }
}

export default BaseModalStatic;
